import { render } from "./VirtualVideo.vue?vue&type=template&id=23bc809f&scoped=true&ts=true"
import script from "./VirtualVideo.vue?vue&type=script&lang=ts"
export * from "./VirtualVideo.vue?vue&type=script&lang=ts"

import "./VirtualVideo.vue?vue&type=style&index=0&id=23bc809f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src129899678/src/web-ext-ai-voucher-humelo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bc809f"]])

export default __exports__